export default __webpack_public_path__ + "static/media/PHI.2f8bc16e.svg";